import { JsonRpcProvider } from 'ethers';
import { Logger, randomString } from '@streamr/utils';
const logger = new Logger('LoggingJsonRpcProvider');
export class LoggingJsonRpcProvider extends JsonRpcProvider {
    urlConfig;
    constructor(urlConfig, network, options) {
        super(urlConfig, network, options);
        this.urlConfig = urlConfig;
    }
    async send(method, params) {
        const traceId = randomString(5);
        const startTime = Date.now();
        const logContext = {
            traceId,
            method,
            params,
            connection: {
                url: this.urlConfig.url,
                timeout: this.urlConfig.timeout
            }
        };
        logger.debug('Send request', logContext);
        let result;
        try {
            result = await super.send(method, params);
        }
        catch (err) {
            logger.debug('Encountered error while requesting', {
                ...logContext,
                err,
                elapsedTime: Date.now() - startTime
            });
            throw err;
        }
        logger.debug('Received response', {
            ...logContext,
            elapsedTime: Date.now() - startTime
        });
        return result;
    }
}
